import React from 'react'
import {getColor} from 'components/utils'
import { TransProps } from '@lingui/react'


// Type
export type typeInputTextarea = {
    variant?: string
    id: string
    name: string
    label?: React.ReactElement<TransProps>
    placeholder?: string
    value?: string
    rows?: number
    required?: boolean
    labelClassName?: string,
    inputClassName?: string,
    errorMessage?: React.ReactElement<TransProps>
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
    onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void
    maxLength?: number

}


// Component
export const InputTextarea:React.FC<typeInputTextarea> = ({
    variant,
    id,
    name,
    label,
    placeholder,
    value,
    rows=3,
    required=false,
    labelClassName,
    inputClassName,
    errorMessage,
    onChange,
    onKeyDown,
    maxLength
}) => {

    const color = getColor(variant)

    const labelStyles = ['block text-sm font-medium text-gray-700', labelClassName].join(' ')
    const inputStyles = [`shadow-sm block w-full focus:ring-${errorMessage? 'red': color}-500 focus:border-${ errorMessage? 'red': color}-500 sm:text-sm border border-${errorMessage? 'red-500': 'gray-300'} rounded-md`, inputClassName].join(' ')

    return(
        <>
            <label
                htmlFor={id}
                className={labelStyles}
            >
                {required && <span className="text-red-600 mr-1">*</span>} {label}
            </label>
            <div className="mt-1">
                <textarea
                    id={id}
                    name={name}
                    placeholder={placeholder}
                    value={value}
                    required={required}
                    rows={rows}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    className={inputStyles}
                    maxLength={maxLength}
                />
                {errorMessage
                    ? <p className="text-xs mt-1 text-red-500">{errorMessage}</p>
                    : null
                }
            </div>
        </>
    )
}
